import Vue from 'vue'
import VueRouter from "vue-router";
import {getCookieByName} from "../assets/js/util";

Vue.use(VueRouter);

const Page = (resolve) => require(['../pages/Page.vue'], resolve);
const Home = (resolve) => require(['../pages/home/Home.vue'], resolve);
const News = (resolve) => require(['../pages/news/News'], resolve);
const AuthorRegister = (resolve) => require(['../pages/author/Register.vue'], resolve);


let router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Page,
            children: [{
                path: '/',
                name: 'home',
                component: Home
            },{
                path: '/news/:classid/:id',
                name: 'news',
                component: News
            },{
              path: '/author/register',
              name: '作者注册',
              component: AuthorRegister,
              meta: {
                requiresAuth:true
              }
            }]
        }
    ]
});

router.beforeEach((to, from, next) => {
  let token = getCookieByName('user_token');
  //如果没有匹配的路由 跳转到首页
  if (to.matched.length === 0) {
    from.name ? next({name: from.name}) : next('/')
  } else {
    next()
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      window.location.href = '//www.iyoule.com';
    } else {
      next()
    }
  }else {
    next() //确保一定要调用next()
  }
});

export default router
